module.exports = __webpack_public_path__ + "img/icon_cancelW.680d195a.svg";